import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum AuditLogPermissionSet {
  View = 'audit_log_view',
  ViewAlertRules = 'audit_log_view_alert_rules',
  WriteAlertRules = 'audit_log_write_alert_rules',
  ViewAlerts = 'audit_log_view_alerts',
}

export const auditLogPermissionSetGrouping: IPermissionSetGrouping<AuditLogPermissionSet> = {
  key: PermissionSetGroupingKey.AuditLog,
  active: {
    [AuditLogPermissionSet.View]: [PermissionType.LIST_ANY_AUDIT_LOG],
    [AuditLogPermissionSet.ViewAlertRules]: [PermissionType.GET_ANY_AUDIT_LOG_ALERT_RULE],
    [AuditLogPermissionSet.WriteAlertRules]: [PermissionType.WRITE_ANY_AUDIT_LOG_ALERT_RULE],
    [AuditLogPermissionSet.ViewAlerts]: [PermissionType.LIST_ANY_AUDIT_LOG_ALERT],
  },
  unAssignablePermissionSets: [],
}
